import instance from '../../../api'

export const changePassword = (id, form) => instance.put('/api/admin/admin_users/me', form)
